import type { AnyAbility } from '@casl/ability';
import { useAbility } from '@casl/react';

/** Returns whether the current ability permits `(action, subject)`. */
export function useCan(action: string, subject: string): boolean {
  const ability = useAbility<AnyAbility>();
  return ability.can(action, subject);
}
